module.exports = __webpack_public_path__ + "Gotham-Light.d14c91838dbff9c6d25e.ttf";


//////////////////
// WEBPACK FOOTER
// /code/frontend/src/assets/fonts/Gotham-Light.ttf
// module id = ../../../../../src/assets/fonts/Gotham-Light.ttf
// module chunks = 2